<script lang="ts" setup>
    import '../../../css/choice.css';
    import { onMounted, ref, reactive } from 'vue';
    import { initPinia } from '../../lib/PiniaMgr';
    import { usePrivilegesStore } from '../../lib/Stores/PrivilegesStore' 
    import { TableRowHighlight, TableRowType, ButtonDisplayStyle } from "../../Enums/UiEnums";
    import { ICol, RenderModeType, IRowSelection } from "../../lib/ChoiceTableHelpers";
    import { ICheckInOutDashboardAppointmentStatusItem, ICheckInOutDashboardStatusWorkflowSaveItem } from '../../lib/Models/ScheduleModel';
    import { ModalStyles, popAlert } from "../../lib/Notification"
    import { ActionButtonStyle } from "../../lib/Types/Types";
    import { ButtonDisplaySize } from "../../Enums/UiEnums";
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import Combo from "../../components/Combo.vue";
    import ActionButtonV2 from '../../components/ActionButtonV2.vue'; 
    import * as ChoiceApi from '../../lib/ChoiceApi';

    const privilegesStore = usePrivilegesStore(initPinia());

    const emit = defineEmits(["changeToSetup"]);

    const props = defineProps<{
        tabId: number
    }>();

    const setupColumns = ref<ICol[]>([
        { Name: 'Enabled', DataField: 'workflowEnabled', RenderMode: RenderModeType.Selection },
        { Name: 'Current Status', DataField: 'fromStatusDescription' },
        { Name: 'New status', DataField: 'toStatusDescription' }
    ]);

    const formData = reactive<{
        statusList: ICheckInOutDashboardAppointmentStatusItem[],
        selectedStatus?: ICheckInOutDashboardAppointmentStatusItem,
        fromStatusId?: number,
        toStatusId?: number
    }>({
        statusList: []
    });

    async function fetchData(){
        formData.statusList = await ChoiceApi.schedule.DashboardStatusList(props.tabId) ?? [];
    }
    fetchData();

    onMounted(async () => {
    });

    function onSearchRowClick(rowData: IRowSelection,  _rowType: TableRowType, _evt: MouseEvent) : void {
        formData.selectedStatus = <ICheckInOutDashboardAppointmentStatusItem> rowData;
        formData.toStatusId = formData.selectedStatus.toStatusId;
    }

    async function saveSetup() {
        const statusList : ICheckInOutDashboardStatusWorkflowSaveItem[] = formData.statusList.map(item => ({fromStatusId: item.fromStatusId, toStatusId: item.toStatusId, enabled: item.workflowEnabled})); 

        const save = {
            tabId: props.tabId,
            statusList: statusList,
        }
        const result = await ChoiceApi.schedule.DashboardStatusWorkflowSave(save);
        if (!result.passed) {
            popAlert("Failed to save the Workflow Settings.", "Save", ModalStyles.danger);
            return;
        }
        emit("changeToSetup");
    }

    function statusChange(selectedItem : any) : void {
        if (!formData.selectedStatus) {
            popAlert("Please select a row.", "New Status", ModalStyles.info);
            return;
        }

        const index = formData.statusList.findIndex(o => o.fromStatusId == formData.selectedStatus?.fromStatusId)
        if (index < 0) 
            return;

        formData.statusList[index].toStatusId = selectedItem?.fromStatusId;
        formData.statusList[index].toStatusDescription = selectedItem?.fromStatusDescription;
    }

</script>

<template>
    <div class="row">
        <div class="col-6"></div>
        <div class="col">
            <span class="col pe-2 isalus-section-header label-isalus-small">
                New Status
            </span>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-6"></div>
        <div class="col">
            <Combo 
                :optionList="formData.statusList"
                optionValue="fromStatusId"
                optionDescription="fromStatusDescription"
                :includeBlank="true"
                v-model:selected="formData.toStatusId"
                @onChange="statusChange" />            
        </div>
    </div>
    <div class="row">
        <div class="col">
            <ChoiceTable 
                ref="searchTable"
                :columns="setupColumns" 
                :data="formData.statusList" 
                :show-filters="false" 
                :allowSorting="false"
                fontSize="smaller"
                :height="400"
                :rowHighlight="TableRowHighlight.onSingleClick"
                @rowclick="onSearchRowClick"
                :key-value-data-member="'fromStatusId'">
            </ChoiceTable>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col text-end">
            <ActionButtonV2 
                :action="ActionButtonStyle.Save"
                :text="'Save Settings'"
                :size="ButtonDisplaySize.Small" 
                :spinText="'Saving'"
                :displayStyle="ButtonDisplayStyle.OutlinePrimary"  
                :performAction="saveSetup"
            />
        </div>
    </div>
</template>

